const locale = {
	pageTitle: 'ISO 9001 品質管理系統驗證 | 擎億精密有限公司',
	pageDesc:
		'擎億精密通過 ISO 9001:2015 品質管理系統國際認證，建立標準化生產流程與完整品質追溯機制，每批產品出貨前均經三次元 CMM 量測與外觀檢驗，確保符合客戶規格與國際品質標準。',
	pageKeywords:
		'ISO 9001, ISO 9001:2015, 品質管理系統, 品質認證, CMM 量測, 精密加工品管, 擎億精密',
	title: 'ISO 9001 品質管理系統驗證',
	subtitle: 'ISO 9001:2015 Quality Management System Certification',
	clickHint: '點擊圖片可放大檢視'
};

export default locale;
